import { Pipe, PipeTransform } from '@angular/core';
import { OrderableItemService, OrderableQualifier } from 'ngx-web-api';

@Pipe({
  name: 'qualifierCalories',
})
export class QualifierCaloriesPipe implements PipeTransform {
  constructor(private orderableItemService: OrderableItemService) {}

  transform(qualifier: OrderableQualifier, size: string, isHalf: boolean): any {
    if (!!qualifier && !!size) {
      return this.orderableItemService.getQualifierCalories(qualifier, size, isHalf);
    }
    return null;
  }
}
